import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
    AUTH_TOKEN,
    SIGNIN,
    SIGNOUT,
    SIGNUP,
    SIGNIN_WITH_GOOGLE,
    SIGNIN_WITH_FACEBOOK,
    PERMISSIONS,
} from '../constants/Auth';
import {
    showAuthMessage,
    authenticated,
    signOutSuccess,
    signUpSuccess,
    signInWithGoogleAuthenticated,
    signInWithFacebookAuthenticated,
    signUpWait,
    setAuthUser,
} from '../actions/Auth';

import FirebaseService from 'services/FirebaseService';
import RestAuthService from 'services/RestAuthService';
import { onLocaleChange } from 'redux/actions';

const SIGNIN1 = 'TEST';
const SIGNOUT1 = 'TEST2';
const SIGNUP1 = 'TEST3';

// const abc = {
//     places: [1, 0, 1, 0],
//     states: [1, 0, 0, 1],
//     roles: [1, 1, 1, 1],
//     privileges: [1, 1, 1, 1],
//     users: [1, 1, 1, 1],
// };
export function* signInWithFBEmail() {
    yield takeEvery(SIGNIN1, function* ({ payload }) {
        const { email, password } = payload;
        try {
            const user = yield call(
                FirebaseService.signInEmailRequest,
                email,
                password
            );
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(authenticated(user.user.uid));
            }
        } catch (err) {
            yield put(showAuthMessage(err));
        }
    });
}
export function* signInWithRestEmail() {
    yield takeEvery(SIGNIN, function* ({ payload }) {
        const { email, password } = payload;
        try {
            const user = yield call(
                RestAuthService.signInEmailRequest,
                email,
                password
            );

            if (user.error !== undefined) {
                if (user.error === true) {
                    // user.message = "Email or password is incorrect";
                    yield put(showAuthMessage(user.message));
                } else {
                    // user.permissions = abc;
                    console.log('test userr', user);

                    localStorage.setItem(
                        PERMISSIONS,
                        JSON.stringify(user.permissions)
                    );
                    localStorage.setItem(AUTH_TOKEN, user.token);
                    localStorage.setItem('jwt', JSON.stringify(user));
                    // yield put(onLocaleChange("en"));
                    yield put(
                        onLocaleChange(user.user.lang ? user.user.lang : 'en')
                    );
                    yield put(setAuthUser(user.user));
                    yield put(authenticated(user));
                }
            } else {
                yield put(showAuthMessage('Networ error, cannot sign in!'));
            }
        } catch (err) {
            yield put(showAuthMessage(err));
        }
    });
}

export function* signOut() {
    yield takeEvery(SIGNOUT1, function* () {
        try {
            const signOutUser = yield call(FirebaseService.signOutRequest);
            if (signOutUser.error === undefined) {
                if (!signOutUser.error) {
                    yield put(signOutSuccess(signOutUser));
                }
            } else {
                yield put(showAuthMessage(signOutUser.message));
            }
        } catch (err) {
            yield put(showAuthMessage(err));
        }
    });
}

export function* signOutRest() {
    yield takeEvery(SIGNOUT, function* () {
        try {
            // const signOutUser = yield call(RestAuthService.signOutRequest);

            // if (signOutUser === undefined) {
            //     if (!signOutUser.error) {
            //         yield put(signOutSuccess(signOutUser));
            //     }
            // } else {
            //     yield put(showAuthMessage(signOutUser.message));
            // }
            yield put(signOutSuccess());
        } catch (err) {
            yield put(showAuthMessage(err));
        }
    });
}

export function* signUpWithFBEmail() {
    yield takeEvery(SIGNUP1, function* ({ payload }) {
        const { email, password } = payload;
        try {
            const user = yield call(
                FirebaseService.signUpEmailRequest,
                email,
                password
            );
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signUpSuccess(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export function* signUpWithRestEmail() {
    yield takeEvery(SIGNUP, function* ({ payload }) {
        const userst = payload;
        try {
            const user = yield call(RestAuthService.singUpRequest, userst);

            if (user.message) {
                if (!user.error) {
                    yield put(signUpWait(user));
                } else {
                    yield put(showAuthMessage(user.message));
                }
            } else {
                // user.permissions = abc;
                localStorage.setItem(
                    PERMISSIONS,
                    JSON.stringify(user.permissions)
                );
                localStorage.setItem(AUTH_TOKEN, user.token);
                localStorage.setItem('jwt', JSON.stringify(user));
                yield put(setAuthUser(user.user));
                yield put(signUpSuccess(user));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export function* signInWithFBGoogle() {
    yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
        try {
            const user = yield call(FirebaseService.signInGoogleRequest);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signInWithGoogleAuthenticated(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export function* signInWithFacebook() {
    yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
        try {
            const user = yield call(FirebaseService.signInFacebookRequest);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signInWithFacebookAuthenticated(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(signInWithFBEmail),
        fork(signInWithRestEmail),
        fork(signOutRest),
        fork(signOut),
        fork(signUpWithFBEmail),
        fork(signUpWithRestEmail),
        fork(signInWithFBGoogle),
        fork(signInWithFacebook),
    ]);
}
